// import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";
import Animations from "../../../assets/src/scripts/animations.js";

export class WysiwygSection {

  constructor($container) {
    if (Core.isAdmin()) return

    this.$container = $container;

    Animations.animateTextFillOnScroll();
  }
}
